import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "relative"
}
const _hoisted_2 = { class: "bg-white rounded mt-87 mx-10 shadow-mainShadow text-start overflow-hidden mb-7" }
const _hoisted_3 = { class: "modal-header border-b" }
const _hoisted_4 = { class: "flex items-center text-textColor justify-between w-full h-15 px-6" }
const _hoisted_5 = { class: "flex justify-start items-end ms-5" }
const _hoisted_6 = { class: "font-bold text-darkText text-xl" }
const _hoisted_7 = { class: "text-base ms-2" }
const _hoisted_8 = { class: "cursor-pointer" }
const _hoisted_9 = { class: "flex justify-between px-6 mt-6" }
const _hoisted_10 = { class: "px-6 text-start mb-1.5" }
const _hoisted_11 = { class: "text-start text-lg mb-9 font-semibold text-darkText" }
const _hoisted_12 = { class: "ms-2" }
const _hoisted_13 = { class: "flex justify-start items-start border-s-2 border-dashed" }
const _hoisted_14 = { class: "flex items-center" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center items-center order-pointer w-5 h-5 rounded-full bg-trackPointerLight relative -start-665" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "w-2.5 h-2.5 rounded-full bg-trackPointer" })
], -1)
const _hoisted_16 = { class: "text-base text-start font-semibold w-20 text-darkText" }
const _hoisted_17 = { class: "text-base text-start text-darkText mb-9" }
const _hoisted_18 = { class: "flex justify-start border-dashed items-start pb-9 border-s-2 last:border-transparent" }
const _hoisted_19 = { class: "flex items-center" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center items-center order-pointer w-5 h-5 rounded-full bg-trackPointerLight relative -start-665" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "w-2.5 h-2.5 rounded-full bg-white" })
], -1)
const _hoisted_21 = { class: "text-base text-start font-semibold w-20 text-darkText text-darkText" }
const _hoisted_22 = { class: "text-base text-start text-darkText text-darkText" }
const _hoisted_23 = { class: "relative text-sm text-textColor" }
const _hoisted_24 = { class: "-ms-2" }
const _hoisted_25 = { class: "flex justify-start mb-6" }
const _hoisted_26 = { class: "text-base text-start font-bold w-44 text-darkText" }
const _hoisted_27 = { class: "text-base text-textColor" }
const _hoisted_28 = { class: "flex justify-start mb-6" }
const _hoisted_29 = { class: "text-base text-start font-bold w-44 text-darkText" }
const _hoisted_30 = { class: "text-base text-textColor" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_32 = { class: "text-lg mb-5 font-bold text-darkText mt-7" }
const _hoisted_33 = { class: "flex justify-start items-center mt-5" }
const _hoisted_34 = { class: "font-bold text-darkText text-base text-start me-5 mb-3 w-27" }
const _hoisted_35 = { class: "me-3 w-2/4 rotate-2 rounded-0.5xl mb-2" }
const _hoisted_36 = { class: "flex justify-end mx-9 mt-8 mb-9" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseIcon = _resolveComponent("BaseIcon")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_OrdersMap = _resolveComponent("OrdersMap")!

  return (_ctx.orderData)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("p", _hoisted_5, [
                _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.orderData.orderId), 1),
                _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.orderData.orderStatus.value), 1)
              ]),
              _createElementVNode("span", _hoisted_8, [
                _createVNode(_component_BaseIcon, {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeModal($event, true))),
                  name: "close"
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.$t('orders.information')), 1),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _hoisted_15,
                    _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.$t('orders.from')), 1)
                  ]),
                  _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.orderData.originalOrder.userAddress), 1)
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _hoisted_20,
                      _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.$t('orders.to')), 1)
                    ]),
                    _createElementVNode("p", _hoisted_22, [
                      _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.orderData.originalOrder.darkStore.name), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("p", _hoisted_26, _toDisplayString(_ctx.$t('orders.originalOrder')), 1),
                    _createElementVNode("p", _hoisted_27, _toDisplayString(_ctx.orderData.originalOrder.orderId), 1)
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("p", _hoisted_29, _toDisplayString(_ctx.$t('orders.totalAmountReturn')), 1),
                    _createElementVNode("p", _hoisted_30, _toDisplayString(_ctx.orderData.amountMoneyToReturn), 1)
                  ])
                ])
              ]),
              _hoisted_31,
              _createElementVNode("p", _hoisted_32, _toDisplayString(_ctx.$t('orders.driverInfo')), 1),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("p", _hoisted_34, _toDisplayString(_ctx.$t('orders.driver')), 1),
                  _createVNode(_component_v_select, {
                    options: _ctx.drivers,
                    "label-by": "value",
                    "value-by": "id",
                    modelValue: _ctx.selectedDriver,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedDriver) = $event)),
                    "clear-on-select": "",
                    "clear-on-close": "",
                    "close-on-select": "",
                    "search-placeholder": "Type to add more"
                  }, {
                    toggle: _withCtx(() => [
                      _createVNode(_component_BaseIcon, {
                        class: "me-4",
                        name: "arrowdown"
                      })
                    ]),
                    _: 1
                  }, 8, ["options", "modelValue"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_35, [
              _createVNode(_component_OrdersMap, {
                id: 'returned-order-details',
                class: "z-40",
                tripDetails: _ctx.tripDetails
              }, null, 8, ["tripDetails"])
            ])
          ]),
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("button", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.cancelOrder())),
              class: "danger-btn px-6 py-3 me-2"
            }, _toDisplayString(_ctx.$t('buttons.cancelOrder')), 1),
            _createElementVNode("button", {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.assignOrder())),
              class: "primary px-6 py-3"
            }, _toDisplayString(_ctx.$t('buttons.assignOrder')), 1)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}